import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import KeyDecisionSummaryEvent from "../event/KeyDecisionSummaryEvent";

export default class KeyDecisionSummaryScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, variableManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._variableManager = variableManager;
        this._content = this.getCustomData().content;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();

        let summaryText = "No ContentID found for this KD summary";
        if(this._content.getContentID() != "") {
            summaryText = this._languagePack.getText(`keyDecisionsSummary.${this._content.getContentID()}.description`);
        }

        this._target.bodyTextField.text = summaryText;
        this._target.titleTextField.text = this._languagePack.getText(`keyDecisionsSummary.${this._content.getContentID()}.title`);
        this._continueButton = this.createButton(this._target.continueButton, this._handleContinueButton.bind(this), this._languagePack.getText(`keyDecisionsSummary.${this._content.getContentID()}.continueButtonLabel`));

    }
    destroy() {
        super.destroy();
    }

    _handleContinueButton() {
        this.dispatch(KeyDecisionSummaryEvent.CLOSE_REQUEST);
    }
}